import AIInfoPinnedScrollWidgetConfig from '../config/aIInfoPinnedScrollWidget.config';

import type { ComprehensiveProductType } from '@atlassian/mpac-widgets';

// Static page element IDs
export const PAGE_ELEMENT_IDS = {
  HERO: 'hero',
  AI_INFO_PINNED_SCROLL_WIDGET: 'ai-info-pinned-scroll-widget',
  AI_APPS_COLLECTIONS: 'ai-apps-collections',
  MEET_ROVO: 'meet-rovo',
  ROVO_APPS_COLLECTIONS: 'rovo-apps-collections',
  STATS_SECTION: 'stats-section',
  FORGE_WIDGET: 'forge-widget',
} as const;

/**
 * Converts a product name to a kebab-case ID format
 * e.g., "Smart Insights" -> "smart-insights"
 */
const productNameToId = (productName: string): string => {
  return productName.toLowerCase().replace(/\s+/g, '-');
};

/**
 * Generates product type IDs from the AI Info Pinned Scroll Widget config
 */
export const generateProductTypeIds = (products: ComprehensiveProductType[]): string[] => {
  return products.map((product) => `product-type-${productNameToId(product.productName)}`);
};

/**
 * Get all product type IDs from the current AI Info configuration
 */
export const PRODUCT_TYPE_IDS = generateProductTypeIds(AIInfoPinnedScrollWidgetConfig.products);

/**
 * All element IDs for engagement tracking
 */
export const ALL_ELEMENT_IDS = [...Object.values(PAGE_ELEMENT_IDS), ...PRODUCT_TYPE_IDS];
